import api from "@/services/api/client";

export interface FeToolPickerArtifactItem {
  id: string;
  name: string;
  type: string | null;
}

export interface FeToolPickerArtifactsResponse {
  items: FeToolPickerArtifactItem[];
}

export interface FeToolPickerReviewTaskItem {
  task_id: string;
  title: string | null;
  client_name: string | null;
}

export interface FeToolPickerReviewTasksResponse {
  items: FeToolPickerReviewTaskItem[];
}

export interface ResourceTypeCatalogEntry {
  type: string;
  label: string;
  purpose: string;
  agent_visibility_note: string;
}

export interface ResourceTypeCatalogResponse {
  items: ResourceTypeCatalogEntry[];
  profile_company_ids?: string[];
}

const CHAT_DEBUG_MENU_BASE = "/agentic/chat-debug-menu";

export async function fetchFeToolPickerArtifacts(
  limit = 20,
): Promise<FeToolPickerArtifactsResponse> {
  const response = await api.get<FeToolPickerArtifactsResponse>(
    `${CHAT_DEBUG_MENU_BASE}/fe-tool-pickers/artifacts`,
    { params: { limit } },
  );
  return response.data;
}

export async function fetchFeToolPickerReviewTasks(
  limit = 20,
): Promise<FeToolPickerReviewTasksResponse> {
  const response = await api.get<FeToolPickerReviewTasksResponse>(
    `${CHAT_DEBUG_MENU_BASE}/fe-tool-pickers/review-tasks`,
    { params: { limit } },
  );
  return response.data;
}

export async function fetchResourceTypeCatalog(): Promise<ResourceTypeCatalogResponse> {
  const response = await api.get<ResourceTypeCatalogResponse>(
    `${CHAT_DEBUG_MENU_BASE}/resource-type-catalog`,
  );
  return response.data;
}
